import React from 'react';
import { configure_customers_select } from '../utils/DictionaryManagementUtils';
import DefaultRecipientList from '../components/PanelsComponents/DefaultPanels/DefaultRecipientList';

//= ========================================================================

const Panel_G02_SplitPaymentRecipientList = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultRecipientList
    globJSON={globJSON}
    onConfigChanged={onConfigChanged}
    onStepPressed={onStepPressed}
    onGotoEdit={onGotoEdit}
    selectedScreen={selectedScreen}
    paragraph={configure_customers_select}
    language={language}
  />
);

export default Panel_G02_SplitPaymentRecipientList;
